import appIcon from '../assets/img/poftigo-appicon.png';
const ENV = {
    dev: "https://poftigodevenv.azurewebsites.net",
    test: "https://testpoftigo.azurewebsites.net",
    live: "https://api.poftigo.app"
}

export { ENV, appIcon };
